import React from 'react';
import ProjectTransitionFields from './ProjectTransitionFields';
import { projectTransitionSchema } from '../../../lib/project-transition-schemas';

export default function BuildForm({ values, onChange, errors }) {
  return <ProjectTransitionFields schema={projectTransitionSchema('build')} values={values} onChange={onChange} errors={errors} />;
}
